import React from 'react';
import { Footer } from '../components/HomePage';
import PlanDetail from '../components/PlanDetail/PaymentMobile';
import { Header } from '../components/HomePage';

function PaymentPage() {
  return (
    <>
      <PlanDetail />
      <Footer />
    </>
  );
}

export default PaymentPage;